import { useEffect } from 'react';

const useManageButtonStates = (props) => {
  const {
    minimumRequiredUploads = 1,
    uploadResponse,
    buttonsToDisable,
    disabledButtons,
    fieldId,
    setDisabledButtons,
  } = props;
  useEffect(() => {
    if (buttonsToDisable.length > 0) {
      buttonsToDisable.forEach((btnId) => {
        if (uploadResponse.length >= Number(minimumRequiredUploads)) {
          if (disabledButtons[btnId] && disabledButtons[btnId][fieldId]) {
            delete disabledButtons[btnId][fieldId];
          }
        } else if (disabledButtons[btnId]) {
          disabledButtons[btnId] = { ...disabledButtons[btnId], [fieldId]: 1 };
        } else {
          disabledButtons[btnId] = { [fieldId]: 1 };
        }
      });
      setDisabledButtons({ ...disabledButtons });
    }
  }, [uploadResponse]);
};

export default useManageButtonStates;
